export default "__VITE_ASSET__DUUr8Tdx__"